import React, { useEffect, useState } from "react";

import { useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { isEmptyObject } from "helpers/formatObject";
import { DialogChildButton, NewDialog } from "components";

export default function NewBaseModel(props) {
  const {
    title,
    graph,
    action,
    disabled,
    children,
    initFilter,
    isPopup = false,
  } = props;
  const init = { ...initFilter };

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState(init);
  const [selectable, setSelectable] = useState(false);
  const [startFetch, setStartFetch] = useState(!isPopup);
  const { userToken } = useSelector((state) => state.auth);

  const { data, loading, refetch } = useQuery(graph.list.query, {
    skip: !startFetch,
    variables: {
      page,
      limit,
      ...filter,
    },
    context: {
      serviceName: graph.list.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onOpen = () => {
    if (!disabled) {
      setOpen(true);
      setStartFetch(true);
    }
  };

  const onClose = () => setOpen(false);
  const clearFilter = () => setFilter(init);

  const result = !isEmptyObject(data) ? data[graph.list.name]?.data : [];
  const total = !isEmptyObject(data) ? data[graph.list.name]?.total : 0;

  const handleSetFilter = (filter) => {
    setPage(1);
    setFilter((prev) => ({ ...prev, ...filter }));
  };

  useEffect(() => {
    initFilter && setFilter(initFilter);
  }, [initFilter]);

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        ...props,
        page,
        limit,
        total,
        result,
        filter,
        loading,
        setPage,
        isPopup,
        onClose,
        refetch,
        setLimit,
        selectable,
        clearFilter,
        setSelectable,
        setStartFetch,
        setFilter: handleSetFilter,
      });
    }
    return child;
  });

  if (isPopup) {
    return (
      <>
        <DialogChildButton title={title} onClick={onOpen} children={action} />
        <NewDialog label={title} open={open} onClose={onClose}>
          {childrenWithProps}
        </NewDialog>
      </>
    );
  }

  return childrenWithProps;
}
